import { CloseRounded } from "@mui/icons-material";
import { Box, CircularProgress, IconButton } from "@mui/material";
import { blue, grey } from "@mui/material/colors";
import { isNil } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";
import Flx from "../../../../../components/layout/Flx";
import Txt from "../../../../../components/typography/Txt";

import { useDispatch, useSelector } from "react-redux";
import FlxGrid from "../../../../../_src_shared/components/layout/FlxGrid.js";
import { htmlStringToText } from "../../../../../_src_shared/utils/functions/htmlStringToText.js";
import JsonPreview from "../../../../../components/common/JsonPreview.js";
import TabPanel from "../../../../../components/navigation/TabPanel.js";
import ToggleTabSwitcher from "../../../../../components/navigation/ToggleTabSwitcher.js";
import Htag from "../../../../../components/typography/Htag.jsx";
import { useLoanFilesHook } from "../../../../../hooks/useLoanFilesHook.js";
import { loanFetchedDataParsedDocsSet } from "../../../../../redux/reducers/loanFetchedDataReducer.js";
import LoanFilePreview from "../LoanFilePreview.js";
import LoanFilesExtractedTable from "../LoanFilesTable/LoanFilesExtractedTable.js";

const LoanParsedDocsPanel = ({}) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const [preview, setPreview] = useState(null);
  const dispatch = useDispatch();
  const files = useSelector((state) => state.loanFetchedData?.parsedDocs);

  const { loading, getParseAndExtractDocuments } = useLoanFilesHook();

  const rootStyles = useMemo(() => {
    return {
      p: 2,
      borderBottom: `1px solid ${grey[300]}`,
    };
  }, []);

  const onRowClicked = useCallback((params) => {
    setPreview(params?.data);
  }, []);

  const getRowStyle = useCallback(
    (params) => {
      if (params?.data?._id === preview?._id) {
        return {
          background: blue[100],
        };
      }
    },
    [preview],
  );
  useEffect(() => {
    if (isNil(files)) {
      getParseAndExtractDocuments({
        dealId: loanDrilldown?._id,
        onSuccessFn: (d) => {
          const filesList = d?.parsed_requested_documents || [];
          dispatch(loanFetchedDataParsedDocsSet(filesList));
        },
      });
    }
  }, []);

  return (
    <Flx column>
      <Flx fw jb ac sx={rootStyles}>
        <Flx column g={0.5}>
          <Htag variant="h3">Parsed & Extracted Documents</Htag>
          <Txt secondary>Click on a file row to preview extracted data.</Txt>
        </Flx>
      </Flx>

      {loading || isNil(files) ? (
        <Flx gap={2} column center sx={{ py: 10 }}>
          <CircularProgress />
          <Txt sx={{ ml: 2 }}>Loading parsed documents...</Txt>
        </Flx>
      ) : (
        <FlxGrid gridTemplateColumns={preview ? "1fr 1fr" : "1fr"} ac>
          <LoanFilesExtractedTable
            rowData={files}
            getRowStyle={getRowStyle}
            onRowClicked={onRowClicked}
          />
          {preview && (
            <LoanParsePreview file={preview} onClose={() => setPreview(null)} />
          )}
        </FlxGrid>
      )}
    </Flx>
  );
};

const VIEW_TYPES = {
  EXTRACTED_DATA_PREVIEW: "Extracted Data Preview",
  EXTRACTED_DATA_RAW_PREVIEW: "Extacted Data Raw JSON",
  UPLOADED_FILE_PREVIEW: "Uploaded File Preview",
  UPLOADED_FILE_RAW_DATA: "Uploaded File Raw JSON",
};
const LoanParsePreview = ({ file, onClose }) => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const [view, setView] = useState(VIEW_TYPES.EXTRACTED_DATA_PREVIEW);

  // const parsedData = useMemo(() => DUMMY_PARSE_DATA_APPRAISAL.data, []);
  const parsedData = useMemo(() => DUMMY, []);
  // const parsedData = useMemo(() => DUMMY_PARSE_DATA_FEASABILITY.data, []);
  return (
    <Box sx={{ background: grey[300], p: 2 }}>
      <Flx sx={{ alignItems: "flex-start" }} jb>
        <Flx column>
          <Txt bold>{file?.file_display_name}</Txt>
          <ToggleTabSwitcher
            value={view}
            variant={"underline"}
            onChange={setView}
            tabs={Object.values(VIEW_TYPES)}
          />
        </Flx>
        <IconButton onClick={onClose}>
          <CloseRounded />
        </IconButton>
      </Flx>
      <Box
        sx={{
          p: 2,
          background: "#ffffff",
          minHeight: "400px",
          borderRadius: 2,
        }}
      >
        <TabPanel tabValue={VIEW_TYPES.EXTRACTED_DATA_PREVIEW} value={view}>
          <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {htmlStringToText(DUMMY)}
          </pre>
        </TabPanel>
        <TabPanel tabValue={VIEW_TYPES.EXTRACTED_DATA_RAW_PREVIEW} value={view}>
          <JsonPreview values={parsedData} />
        </TabPanel>
        <TabPanel tabValue={VIEW_TYPES.UPLOADED_FILE_PREVIEW} value={view}>
          <Box sx={{ height: "80vh" }}>
            <LoanFilePreview
              headerSx={{ pl: 0, pt: 0 }}
              fileObject={file}
              loan={loanDrilldown}
            />
          </Box>
        </TabPanel>
        <TabPanel tabValue={VIEW_TYPES.UPLOADED_FILE_RAW_DATA} value={view}>
          <JsonPreview values={file} />
        </TabPanel>
      </Box>
    </Box>
  );
};

const DUMMY = `APPRAISER

- APPRAISER NAME Andrew Moon
- APPRAISER LICENSE EXPIRATION DATE 02/05/2026
- APPRAISER LICENSE NUMBER AR033062
- APPRAISER COMPANY Appraisal Solution
- APPRAISER PHONE NUMBER 213-387-4430
- APPRAISER EMAIL ADDRESS appraisalsolutioninc@gmail.com
- APPRAISER INSURANCE EXPIRATION DATE 04/25/2026
- APPRAISER INSURANCE POLICY NUMBER RAP3363972-25
- APPRAISAL SOFTWARE TOTAL by a la mode, inc.

APPRAISAL REPORT DATE
- 2025-10-19

AS IS VALUE
- 1,340,000

SALES COMPARISON APPROACH VALUE
- 1340000

COST APPROACH VALUE
- 1349050

INCOME APPROACH VALUE

PURCHASE CONTRACT PRICE

- 1336000
LOAN TRANSACTION TYPE

- Purchase Transaction
CURRENT OCCUPANCY

- Vacant
PROPERTY LISTING STATUS

- true
PROPERTY LISTING INFO

- DOM 0; The property was listed for sale however not listed on the CRMLS
PROPERTY RIGHTS

- Fee Simple
APPRAISAL FORM TYPE

- Fannie Mae Form 1004 March 2005 / Freddie Mac Form 70 UAD
PURCHASE CONTRACT DATE

- 09/30/2025
SUBJECT PROPERTY

 `;

export default LoanParsedDocsPanel;
